"use client";
import "./index.css"
import useMobileDetect from "@/hooks/useMobileDetect";

export type BrInputNumberProps = {
    isDrawer?: boolean;
    value: number;
    onChange: (type: string, value: number) => void;
    disabled?: boolean;
    height?: string;
    width?: string;
    min?: number;
    max?: number;
    borderRadius?: number;
};
export const BravveInputNumber: React.FC<BrInputNumberProps> = ({
    ...props
}) => {
    const isMobile = useMobileDetect();
    const { value, isDrawer, disabled = false, onChange, height, width, borderRadius, min = 1, max = 5 } = props;

    /**
     * 输入框改变事件
     */
    const onInputChange = (type: string) => {
        if (disabled) return

        if (type == 'plus' && value === max) {
            return
        }

        if (type == 'minus' && value == min) {
            return
        }

        let eventValue = type == 'plus' ? value + 1 : value - 1
        onChange && onChange(type, eventValue || value)
    }

    return (
        <div className='cart-input-number'>
            <div key={value} className="flex items-center justify-center border-[1.5px] p-[8px]" style={{ width: width || '120px', height: height || '40px', borderColor: '#C6C0BD', borderRadius: borderRadius || '2px' }} >
                <iconpark-icon icon-id="minus" name="minus" color={`${value == min || disabled ? '#796B64' : '#402C22'}`} size={isMobile || isDrawer ? '1.8rem' : '2.4rem'} style={{  cursor: value == min ? 'not-allowed' : 'pointer' }} onClick={() => onInputChange('minus')}></iconpark-icon>
                <div className={`${disabled ? 'text-bravve-300' : 'text-bravve-100'} flex-1 text-center text-[18px] leading-[26px] font-medium`}>{value}</div>
                <iconpark-icon icon-id="plus" name="plus" color={`${value == max || disabled ? '#796B64' : '#402C22'}`} size={isMobile || isDrawer ? '1.8rem' : '2.4rem'} style={{ cursor: value == max ? 'not-allowed' : 'pointer', }} onClick={() => onInputChange('plus')}></iconpark-icon>
            </div>
        </div>
    );
}